// Master data (every dropdown list in the portal) — the screen's strings in the portal's four languages (2026-10-21).
// Catalogue names, groups and extra-column labels come from the server and are not here.
const en = {
  title: 'Master data',
  intro: 'Every dropdown list in the portal. <b>Used</b> counts the live records still pointing at a value — a value in use can be switched off, but not deleted.',
  loading: 'Loading…',
  pickCatalogue: 'Pick a catalogue.',
  usedBy: 'used by <c>{{tables}}</c>',
  refresh: 'Refresh',
  addValue: 'Add value',
  searchPh: 'Search this list…',
  countN: '{{n}} values',
  countOf: '{{n}} of {{total}} values',
  col: {
    value: 'Value',
    code: 'Code',
    order: 'Order',
    used: 'Used',
    active: 'Active',
    lastChange: 'Last change',
    action: 'Action',
  },
  sortBy: 'Sort by {{label}}',
  newValuePh: 'New value',
  codePh: 'code',
  saving: 'Saving…',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  activeAria: 'Active',
  switchedOff: 'Switched off',
  usedTitle: 'Used by {{n}} record(s) — switch it off instead',
  deleteTitle: 'Delete this value',
  confirmDelete: 'Delete "{{name}}"? Nothing uses it.',
  added: 'Added "{{name}}"',
  saved: 'Saved "{{name}}"',
  deleted: 'Deleted "{{name}}"',
  empty: 'Nothing in this list yet.',
  requestFailed: 'Request failed ({{status}})',
};

const ko = {
  title: '기준 데이터 관리',
  intro: '포털의 모든 드롭다운 목록입니다. <b>사용</b>은 아직 해당 값을 가리키는 활성 레코드 수입니다 — 사용 중인 값은 끌 수는 있지만 삭제할 수는 없습니다.',
  loading: '불러오는 중…',
  pickCatalogue: '목록을 선택하세요.',
  usedBy: '사용처 <c>{{tables}}</c>',
  refresh: '새로고침',
  addValue: '값 추가',
  searchPh: '이 목록에서 검색…',
  countN: '값 {{n}}개',
  countOf: '값 {{total}}개 중 {{n}}개',
  col: {
    value: '값',
    code: '코드',
    order: '순서',
    used: '사용',
    active: '활성',
    lastChange: '최종 변경',
    action: '작업',
  },
  sortBy: '{{label}} 기준 정렬',
  newValuePh: '새 값',
  codePh: '코드',
  saving: '저장 중…',
  save: '저장',
  cancel: '취소',
  edit: '편집',
  activeAria: '활성',
  switchedOff: '꺼짐',
  usedTitle: '레코드 {{n}}개에서 사용 중 — 대신 끄세요',
  deleteTitle: '이 값 삭제',
  confirmDelete: '"{{name}}"을(를) 삭제할까요? 사용하는 곳이 없습니다.',
  added: '"{{name}}" 추가됨',
  saved: '"{{name}}" 저장됨',
  deleted: '"{{name}}" 삭제됨',
  empty: '이 목록에는 아직 값이 없습니다.',
  requestFailed: '요청 실패 ({{status}})',
};

const vi = {
  title: 'Dữ liệu gốc',
  intro: 'Mọi danh sách thả xuống trong portal. Cột <b>Đang dùng</b> đếm số bản ghi còn hiệu lực đang trỏ tới một giá trị — giá trị đang được dùng chỉ có thể tắt, không thể xóa.',
  loading: 'Đang tải…',
  pickCatalogue: 'Hãy chọn một danh mục.',
  usedBy: 'được dùng bởi <c>{{tables}}</c>',
  refresh: 'Làm mới',
  addValue: 'Thêm giá trị',
  searchPh: 'Tìm trong danh sách này…',
  countN: '{{n}} giá trị',
  countOf: '{{n}} / {{total}} giá trị',
  col: {
    value: 'Giá trị',
    code: 'Mã',
    order: 'Thứ tự',
    used: 'Đang dùng',
    active: 'Hoạt động',
    lastChange: 'Thay đổi gần nhất',
    action: 'Thao tác',
  },
  sortBy: 'Sắp xếp theo {{label}}',
  newValuePh: 'Giá trị mới',
  codePh: 'mã',
  saving: 'Đang lưu…',
  save: 'Lưu',
  cancel: 'Hủy',
  edit: 'Sửa',
  activeAria: 'Đang hoạt động',
  switchedOff: 'Đã tắt',
  usedTitle: 'Đang được {{n}} bản ghi dùng — hãy tắt thay vì xóa',
  deleteTitle: 'Xóa giá trị này',
  confirmDelete: 'Xóa "{{name}}"? Không có gì đang dùng giá trị này.',
  added: 'Đã thêm "{{name}}"',
  saved: 'Đã lưu "{{name}}"',
  deleted: 'Đã xóa "{{name}}"',
  empty: 'Danh sách này chưa có giá trị nào.',
  requestFailed: 'Yêu cầu thất bại ({{status}})',
};

const zh = {
  title: '主数据',
  intro: '门户中的所有下拉列表。<b>使用数</b>统计仍指向某个值的有效记录数——正在使用的值只能停用，不能删除。',
  loading: '加载中…',
  pickCatalogue: '请选择一个目录。',
  usedBy: '被 <c>{{tables}}</c> 使用',
  refresh: '刷新',
  addValue: '添加值',
  searchPh: '在此列表中搜索…',
  countN: '{{n}} 个值',
  countOf: '{{n}} / {{total}} 个值',
  col: {
    value: '值',
    code: '代码',
    order: '顺序',
    used: '使用数',
    active: '启用',
    lastChange: '最近更改',
    action: '操作',
  },
  sortBy: '按{{label}}排序',
  newValuePh: '新值',
  codePh: '代码',
  saving: '保存中…',
  save: '保存',
  cancel: '取消',
  edit: '编辑',
  activeAria: '启用',
  switchedOff: '已停用',
  usedTitle: '有 {{n}} 条记录在使用——请改为停用',
  deleteTitle: '删除此值',
  confirmDelete: '删除“{{name}}”？没有任何记录使用它。',
  added: '已添加“{{name}}”',
  saved: '已保存“{{name}}”',
  deleted: '已删除“{{name}}”',
  empty: '此列表中还没有值。',
  requestFailed: '请求失败 ({{status}})',
};

const dictionary = { ns: 'xMasterData', en, ko, vi, zh };

export default dictionary;
